"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.widgetMobileBreakPoint = void 0;

var _styles = require("@material-ui/core/styles");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var widgetMobileBreakPoint = 600;
exports.widgetMobileBreakPoint = widgetMobileBreakPoint;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    container: {
      display: 'flex',
      alignItems: 'center',
      marginRight: 12
    },
    titleOverflow: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    title: _defineProperty({}, theme.breakpoints.down(widgetMobileBreakPoint), {
      left: 0,
      margin: '0',
      overflow: 'hidden',
      padding: '4px 24px',
      position: 'absolute',
      right: 0,
      textAlign: 'start',
      textOverflow: 'ellipsis',
      top: '54px',
      whiteSpace: 'nowrap',
      backgroundColor: '#FEFEFE',
      color: theme.palette.text.primary
    }),
    divider: _defineProperty({
      height: '40px',
      border: "1px solid ".concat(theme.palette.background.hover || '#E0E0E0'),
      margin: '0 12px'
    }, theme.breakpoints.down(widgetMobileBreakPoint), {
      display: 'none'
    })
  };
});
var _default = useStyles;
exports.default = _default;